import { DocsExamples } from "@/types/docs-reference";

import primary from "./primary.mml";

export const examples: DocsExamples = {
  primary: {
    title: "Basic connection event",
    description: "This is a basic connection event.",
    code: primary,
  },
};
